import { useUser } from '@/stores/userStore';
import { request } from '@/services/requestService';

const sessionIdKey = 'rs-session-id';

export const getSessionId = (): string => {
	let id = sessionStorage.getItem(sessionIdKey);
	if (!id) {
		id = crypto.randomUUID();
		sessionStorage.setItem(sessionIdKey, id);
	}
	return id;
};

export const trackPageView = (routeName: string, path: string): void => {
	const user = useUser();
	if (user.isLoggedIn) {
		void request('activity', 'trackPageView', {
			routeName,
			path,
			sessionId: getSessionId(),
		});
	}
};
